import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../theme";
export const Logo = ({ className = "" }) => (_jsx(LogoImage, { className: `image-reside-logo ${className}`, width: "149", height: "96", alt: "RESIDE" }));
const LogoImage = styled.img `
  display: block;
  margin: 0 auto;
`;
